<template>
    <div class="shot-court">
        <!-- the court drawn on the lines of the old image (550 x 550), so the stored positions stay where they were -->
        <svg class="shot-court__floor" viewBox="0 0 550 550" preserveAspectRatio="none" aria-hidden="true">
            <defs>
                <linearGradient id="shot-court-floor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stop-color="#2e2e2e" />
                    <stop offset="100%" stop-color="#202020" />
                </linearGradient>
                <clipPath id="shot-court-inside">
                    <rect x="14.5" y="12.5" width="520.5" height="521" />
                </clipPath>
            </defs>

            <rect width="550" height="550" fill="#1b1b1b" />
            <rect x="14.5" y="12.5" width="520.5" height="521" fill="url(#shot-court-floor)" />

            <g clip-path="url(#shot-court-inside)">
                <!-- inside the 3pt line, the paint, the logo in the centre circle -->
                <circle cx="274.5" cy="-3" r="238.7" fill="rgba(3, 229, 183, 0.05)" />
                <rect x="223" y="12.5" width="104" height="146" fill="rgba(3, 229, 183, 0.14)" />
                <image :href="logo" x="215" y="462" width="120" height="68" opacity="0.22" preserveAspectRatio="xMidYMid meet" />

                <g fill="none" stroke="rgba(255, 255, 255, 0.55)" stroke-width="2.5">
                    <circle cx="274.5" cy="-3" r="238.7" stroke="#03e5b7" stroke-opacity="0.75" />
                    <line x1="223" y1="12.5" x2="223" y2="158.5" />
                    <line x1="327" y1="12.5" x2="327" y2="158.5" />
                    <line x1="223" y1="158.5" x2="327" y2="158.5" />
                    <circle cx="275" cy="158.5" r="55" />
                    <circle cx="274.5" cy="540" r="90" />
                </g>
            </g>

            <rect x="14.5" y="12.5" width="520.5" height="521" fill="none" stroke="rgba(255, 255, 255, 0.55)" stroke-width="2.5" />
        </svg>

        <span
            v-for="(shot, index) in shots"
            :key="index"
            class="shot-court__shot"
            :class="shot.throwStatus === 'made' ? 'shot-court__shot--made' : 'shot-court__shot--missed'"
            :style="getShotStyle(shot)"
        >
            <info-tip :text="shot.playerName ? `${shot.playerName} · ${shot.throwStatus === 'made' ? 'εύστοχο' : 'άστοχο'}` : ''" block>
                <v-icon v-if="shot.throwStatus !== 'made'" size="12">mdi-close-thick</v-icon>
            </info-tip>
        </span>
    </div>
</template>

<script>
    // older shots kept the top-left corner of a 24px mark on a court of 550px: the shot itself is 12px further;
    // the newer ones (centered) are the spot of the tap
    const MARK_OFFSET = 12 / 550

    export default {
        name: 'ShootingChart',
        props: {
            shots: {
                type: Array,
                default: () => []
            }
        },
        data: () => ({
            logo: require('@/assets/main_logo.png')
        }),
        methods: {
            // the positions are fractions of the court, so the chart can take any size
            getShotStyle(shot) {
                const shift = shot.centered ? 0 : MARK_OFFSET
                return {
                    left: `${(shot.x + shift) * 100}%`,
                    top: `${(shot.y + shift) * 100}%`
                }
            }
        }
    }
</script>

<style lang="css" scoped>
.shot-court {
    position: relative;
    width: 350px;
    max-width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 8px;
    overflow: hidden;
}

.shot-court__floor {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.shot-court__shot {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    cursor: default;
}

/* the tip fills the dot, the cross in the middle of it */
.shot-court__shot ::v-deep .info-tip {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* made: a mint dot */
.shot-court__shot--made {
    background: #03e5b7;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px rgba(3, 229, 183, 0.35), 0 2px 6px rgba(0, 0, 0, 0.4);
    z-index: 1;
}

/* missed: a red cross */
.shot-court__shot--missed .v-icon {
    color: #ff5a5a !important;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.6));
}

.shot-court__shot--missed {
    width: 14px;
    height: 14px;
}
</style>
